/* eslint-disable no-unused-vars */
// 混入主题
import { wsInstall } from "./ws";
import systemGlobalSetting from "../mixins/systemGlobalSetting.js";
import multiRouter from "./multiRouter.js";

let designPages = {};
let routeLoadedState = {};
//注册初始化要执行的函数
let initFns = [];

// let pathName = window.location.pathname;
// let root = pathName.substring(0, pathName.substr(1).indexOf("/") + 1);
// if (root) {
//   root = root.substr(1);
// }
// let startKey = "login-start" + (root ? "-" + root : "");
// let timerKey = "login-timer" + (root ? "-" + root : "");
// let startTime = "";
window.addEventListener("beforeunload", () => {
  // sendBeacon();
});
function sendBeacon() {
  // if (dsf.config.setting_public_page_timer == "1") {
  //   if (navigator.sendBeacon) {
  //     if (sessionStorage.getItem(timerKey)) {
  //       let timer = parseInt(sessionStorage.getItem(timerKey));
  //       let url = dsf.url.getWebPath("abc");
  //       let formData = new FormData();
  //       formData.set("timer", timer / 1000);
  //       formData.set("appliction", root);
  //       navigator.sendBeacon(url, formData);
  //     }
  //   }
  // }
}
//初始化vue-router,加入默认守卫和重写其中部分函数
function initRouter(router, clientString) {
  //修正vue-router在跳转地址与当前路由相同的情况下报错
  const VueRouterPush = router.push;
  const VueRouterReplace = router.replace;
  if (dsf.isMultiPage()) {
    let _init = router.init;
    router.init = dsf.noop;
    router.multiInit = overRouteInit;
  }
  router.push = function push(to) {
    return VueRouterPush.call(this, to).catch((err) => {
      dsf.warn(err);
    });
  };
  router.replace = function replace(to) {
    let p = VueRouterReplace.call(this, to);
    p.catch((err) => {
      dsf.warn(err);
    });
    return p;
  };
  let targetRoute = null;
  //检查动态组件（通过设计器配置的页面），并动态创建路由
  if (clientString) {
    router.beforeEach((to, from, next) => {
      let matched = to.matched;
      //当没有匹配到路由或者匹配到*路由时
      let isMatched = matched.length <= 0 || matched[0].path == "*";
      let clientPart = "/" + clientString + "/";
      targetRoute = to;
      //判断如果匹配结果matched的path为*且components属性没有表示当前地址没有被匹配到。如果此时前缀为pc或者mobile则尝试动态加载配置的页面
      if (
        isMatched &&
        dsf.isUnDef(matched.components) &&
        to.path.startsWith(clientPart) &&
        !designPages[to.path]
      ) {
        /**
         * 动态路由
         */
        let rmCode = to.path.substr(clientPart.length).replace(/\//g, ".");
        let rmCodeArr = rmCode.split(".");
        let nameSpace = rmCodeArr.slice(0, rmCodeArr.length - 1).join(".");
        let pageName = rmCodeArr[rmCodeArr.length - 1];
        if (!routeLoadedState[rmCode]) {
          routeLoadedState[rmCode] = "loading";
        } else if (routeLoadedState[rmCode] == "loading") {
          return;
        }
        dsf
          .dynamicComponent(rmCode, clientString)
          .then((result) => {
            let pageTitle = dsf.express.replace(result.pageTitle, dsf.config);
            let routeConfig = crateRouteConfig(router, to, {
              options: result,
              nameSpace: nameSpace,
              pageName: pageName,
              pageTitle
            });
            let routes = router.getRoutes();
            let index = _.findIndex(routes, (it) => {
              return it.path == routeConfig.path;
            });
            index < 0 && addRoute(router, routeConfig);
            routeLoadedState[rmCode] = "loaded";
            designPages[to.path] = true;
            //如果用户输入地址的时候并没有输入路由信息
            if (from.path == "/") {
              next({
                path: to.fullPath,
                replace: true
              });
            }
            //强制修改to属性的matched和meta
            else {
              // routerTransitionTo(router, to);
              next(to.fullPath);
            }
          })
          .catch((err) => {
            err && dsf.error(err);
            dsf.error("动态组件加载失败请查看html请求是否为404或500,或者vue-router版本过低");
            routeLoadedState[rmCode] = "error";
            next();
          })
          .finally(() => {
            //此处next必须设置为null否则多页面模式下由于路由中存在闭包函数会有路由内存泄漏
            delete routeLoadedState[rmCode];
            next = null;
          });
      } else {
        next();
        //此处next必须设置为null否则多页面模式下由于路由中存在闭包函数会有路由内存泄漏
        next = null;
      }
    });
  }
  router.onError((error) => {
    const pattern = /Loading chunk [a-zA-z0-9._]+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      //当加载异步路有时如果出现加载错误重新请求
      console.error("重新加载路由");
      history.replaceState(null, null, "#" + targetRoute.fullPath);
      window.location.reload();
      targetRoute = null;
    } else {
      dsf.error(error);
      dsf.layer.message("路由加载时发生错误", false);
    }
  });
  //将路由参数外放到window全局对象，使dsf.express表达式获取url参数功能可用
  router.afterEach((to, from) => {
    // console.log("afterEach", to, from);
    targetRoute = null;
    if (clientString === "pc") {
      dsf.memoryRelease();
      iframeDialogTitle(to.meta.title);
    }
    //记录页面停留时间长
    if (dsf.config.setting_public_page_timer == "1") {
      dsf.stayTimer.start(to, from);
    }
  });
}

//动态路由强制重新定位
// function routerTransitionTo(router, to) {
//   if (to.matched[0] && to.matched[0].path == "*") {
//     delete to.params.pathMatch;
//     const matchedResult = router.match(to.fullPath, router.history.current);
//     to.matched.length = matchedResult.matched.length;
//     _.each(matchedResult.matched, (m, i) => {
//       // enteredCbs存放着路由钩子中next传递的回调函数
//       // 这里必须保存进新的路由中，否则next中的回调不会执行
//       if (to.matched[i]?.enteredCbs) {
//         m.enteredCbs = to.matched[i].enteredCbs;
//       }
//       to.matched[i] = m;
//     });
//     for (let k in to["meta"]) {
//       delete to["meta"][k];
//     }
//     for (let k in matchedResult["meta"]) {
//       to["meta"][k] = matchedResult["meta"][k];
//     }
//     router.history.pending = to;
//   }
// }
//创建路由数据
function crateRouteConfig(router, toRoute, { nameSpace, pageName, pageTitle, options }) {
  return {
    path: dsf.isString(toRoute) ? toRoute : toRoute.path,
    name: options.name,
    component: options,
    meta: {
      fromDesigner: true,
      needLogin: options.needLogin,
      title: pageTitle,
      keepAlive: options.isKeepAlive,
      level: options.pageLevel || 1,
      waterMark: options.waterMark,
      isDataView: options.pageType === "dataview"
    },
    props(router) {
      return {
        nameSpace: nameSpace,
        pageName: pageName,
        queryString: router.query
      };
    }
  };
}
//添加路由
function addRoute(router, route) {
  //vue-router版本兼容,addRoutes函数超过3.5.1后被取消，要用router.addRoute代替
  router.addRoute ? router.addRoute(route) : router.addRoutes([route]);
}

//重置路由初始化函数，多页签模式下让其不触发页面路径变化时触发路由守卫
function overRouteInit(app) {
  var _this = this;
  this.apps.push(app);
  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once("hook:destroyed", function () {
    // clean out app from this.apps array once destroyed
    var index = _this.apps.indexOf(app);
    if (index > -1) {
      _this.apps.splice(index, 1);
    }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (_this.app === app) {
      _this.app = _this.apps[0] || null;
    }

    if (!_this.app) {
      _this.history.teardown();
    }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return;
  }
  this.app = app;

  // var history = this.history;

  // if (history instanceof HTML5History || history instanceof HashHistory) {
  //   var handleInitialScroll = function (routeOrError) {
  //     var from = history.current;
  //     var expectScroll = this$1.options.scrollBehavior;
  //     var supportsScroll = supportsPushState && expectScroll;

  //     if (supportsScroll && 'fullPath' in routeOrError) {
  //       handleScroll(this$1, routeOrError, from, false);
  //     }
  //   };
  //   var setupListeners = function (routeOrError) {
  //     history.setupListeners();
  //     handleInitialScroll(routeOrError);
  //   };
  //   history.transitionTo(
  //     history.getCurrentLocation(),
  //     setupListeners,
  //     setupListeners
  //   );
  // }

  // history.listen(function (route) {
  //   this$1.apps.forEach(function (app) {
  //     app._route = route;
  //   });
  // });
}

//更新iframe弹出层的标题，前提是使用了DsfIframeDialog
function iframeDialogTitle(title) {
  if (window?.frameElement?.$dialog?.$parent) {
    if (!window?.frameElement?.$dialog?.$parent.title) {
      window.frameElement.$dialog.$parent.title = title;
    }
  }
}
//全局混入
function globalMixin(Vue, context) {
  if (context) {
    Vue.mixin(context);
  }
}
//预加载动态页面路由
function preloads(paths, router, clientString) {
  let routers = {};
  _.each(paths, (el) => {
    routers[el.href] = false;
  });
  return new Promise((resolve, reject) => {
    if (paths.length <= 0) {
      resolve();
    }
    _.each(paths, (e, i) => {
      let clientPart = "/" + clientString + "/";
      let path = e.href;
      let rmCode = path.substr(clientPart.length).replace(/\//g, ".");
      let rmCodeArr = rmCode.split(".");
      let nameSpace = rmCodeArr.slice(0, rmCodeArr.length - 1).join(".");
      let pageName = rmCodeArr[rmCodeArr.length - 1];
      dsf
        .dynamicComponent(rmCode, clientString)
        .then((result) => {
          const pageTitle = dsf.express.replace(result.pageTitle, dsf.config);
          let routeConfig = crateRouteConfig(router, path, {
            options: result,
            nameSpace: nameSpace,
            pageName: pageName,
            pageTitle
          });
          let routes = router.getRoutes();
          let index = _.findIndex(routes, (it) => {
            return it.path == routeConfig.path;
          });
          index < 0 && addRoute(router, routeConfig);
          designPages[path] = true;
        })
        .catch((err) => {})
        .finally(() => {
          routers[e.href] = true;
          let result = _.filter(routers, (el) => !el);
          if (result.length <= 0) {
            resolve();
          }
        });
    });
  });
}
//初始化平台
function initPlatform(Vue, options = {}) {
  dsf.initedComponent = "initing";
  //初始化时将客户端浏览器类型写入cookie
  dsf.cookies.set("client_info", dsf.base64.encode(JSON.stringify(dsf.client.info)));
  dsf.performance.start("初始化dsf");
  dsf.initComponents();
  dsf.initedComponent = "inited";
  var $bus = null;
  //判断网络连接
  if (window && dsf.config.setting_public_watchnetonline) {
    if (dsf.isDef(window?.navigator?.onLine) && !window.navigator.onLine) {
      dsf.layer.message("网络连接异常", false);
    }
    window.addEventListener("offline", () => {
      dsf.layer.message("网络连接异常", false);
    });
    window.addEventListener("online", () => {
      dsf.layer.message("网络已连接");
    });
  }
  //PC端关闭ctrl+-\ctrl鼠标滚缩放页面监听。校准pc端chrome浏览器缩放
  dsf.screenZoom.init();

  //页面加载
  window.addEventListener("load", () => {
    if (
      window._spv_ &&
      window?.frameElement &&
      dsf.isDef(window.frameElement.getAttribute("dsf-spv"))
    ) {
      if (window.frameElement.opener && !window.frameElement.opener.closed) {
        try {
          window.opener = window.frameElement.opener;
          window?.frameElement?.setTitle?.(document.title);
        } catch (ex) {
          dsf.warn(ex);
        }
      }
    }
  });
  if (window.$isMobile) {
    //如果页面初始状态存在van-number-keyboard标记，则删除（多个版本前遗留的一个bug）会导致样式问题
    let vanNumberKeyboard = document.body.querySelector("van-number-keyboard");
    if (vanNumberKeyboard) {
      document.body.removeChild(vanNumberKeyboard);
    }
    // let iphoneSafari = dsf.client.info.os == "iOS" && dsf.client.safari() && dsf.client.info.version.startsWith("15.");
    // iphoneSafari ? document.body.classList.add("ios-safari-browser") : document.body.classList.remove("ios-safari-browser");
  }
  dsf.global.Vue = Vue;
  Vue.prototype.dsf = dsf;
  //生成弹框类函数
  const messageBox = ["message", "confirm", "alert", "loading", "closeLoading"];
  for (let i = 0; i < messageBox.length; i++) {
    const key = messageBox[i];
    const fnName = `$${key}`;
    Vue.prototype[fnName] = function () {
      const args = Array.prototype.slice.call(arguments, 0);
      const vm = this.$vm ? this.$vm : this;
      return dsf.layer[key].apply(vm, args);
    };
  }
  // Vue.prototype.$message = function () {
  //   let args = Array.prototype.slice.call(arguments, 0);
  //   let vm = this.$vm ? this.$vm : this;
  //   return dsf.layer.message.apply(vm, args);
  // };
  // Vue.prototype.$confirm = function () {
  //   let args = Array.prototype.slice.call(arguments, 0);
  //   let vm = this.$vm ? this.$vm : this;
  //   return dsf.layer.confirm.apply(vm, args);
  // };
  // Vue.prototype.$alert = function () {
  //   let args = Array.prototype.slice.call(arguments, 0);
  //   let vm = this.$vm ? this.$vm : this;
  //   return dsf.layer.alert.apply(vm, args);
  // };
  // Vue.prototype.$loading = function () {
  //   let args = Array.prototype.slice.call(arguments, 0);
  //   let vm = this.$vm ? this.$vm : this;
  //   return dsf.layer.loading.apply(vm, args);
  // };
  // Vue.prototype.$closeLoading = function () {
  //   let args = Array.prototype.slice.call(arguments, 0);
  //   let vm = this.$vm ? this.$vm : this;
  //   return dsf.layer.closeLoading.apply(vm, args);
  // };
  // 打开地址
  Vue.prototype.$open = function ({ url = "", state = 4, ...args }) {
    let topWin = dsf.getTopWindow();
    let result = {
      closed: () => {}
    };
    if (this.isDesign || !url) return result;
    // 判断是否从小程序中打开另一个小程序
    // url格式 mp://微信appid.支付宝appid/pages/login/dlogin?xxx=xxx
    if (url.startsWith("mp://")) {
      // 判断是否在小程序中
      if (dsf.driver.$type == "miniapp") {
        let res = dsf.url.parse(url);
        dsf.driver.navigateToMiniProgram({
          appId: res.host,
          path: res.pathname + "?" + dsf.url.serialize(res.searchQuery),
          extraData: {}
        });
      }
      return result;
    }
    if (!state) {
      state = 4;
    }
    if (topWin.__multiPageVm__) {
      if (state != 3) {
        state = 2;
      }
    }
    setTimeout(() => {
      var isRoute = url.startsWith("#/");
      switch (state.toString()) {
      // // 主窗口打开
      // case "1":
      //   if (isRoute) {
      //     location.href = url;
      //   }
      //   else {
      //     location.href = dsf.url.getWebPath(url);
      //   }
      //   break;
      // 新窗口打开
      case "2":
        let win = this.$openWindow(url);
        if (win && win.document) {
          let timeId = setInterval(() => {
            if (win.document && win.closed) {
              if (dsf.isDef(args.close)) {
                result.closed(win);
              }
              clearInterval(timeId);
            }
          }, 1000);
        }
        break;
        // 对话框打开
      case "3":
        if (!args) args = {};
        let dialogOptions = {
          title: "",
          width: "70vw",
          height: "60vh",
          closed: () => {
            result.closed();
          },
          ...args
        };
        if (!dialogOptions.params) dialogOptions.params = {};
        if (/.*\#\/iframeloader.*/.test(url)) {
          dialogOptions.content = "DsfDialogIframe";
          let urlInfo = dsf.url.parse(url);
          dialogOptions.params.rmiframeUrl = urlInfo.hashQuery.src;
        } else {
          dialogOptions.params.path = url;
        }
        this.$openDialog(dialogOptions);
        break;
        // 当前窗口打开
      default:
        if (isRoute) {
          const routerUrl = url.replace("#/", "/");
          this.$router.push(routerUrl);
          // location.href = url;
        } else {
          location.href = dsf.url.getWebPath(url);
        }
        break;
      }
    }, 0);
    return result;
  };
  //获取真实静态数据
  Vue.prototype.$getRealStaticValue = function (v) {
    if (dsf.isString(v)) {
      v = this.$replace(v);
      if (dsf.type(v) == "date") {
        v = dsf.date.format(v, "yyyy-mm-dd");
      }
    } else if (dsf.isObject(v)) {
      let ov = v;
      v = {};
      for (let k in ov) {
        v[k] = this.$getRealStaticValue(ov[k]);
      }
    } else if (dsf.isArray(v)) {
      let ov = v;
      v = [];
      for (let i = 0; i < ov.length; i++) {
        let obj = this.$getRealStaticValue(ov[i]);
        v.push(obj);
      }
    }
    return v;
  };
  //设计器中提交页面变化用于ctrl+z ctrl+y前进
  Vue.prototype.$recordPageChange = function () {
    if (this?.$designId && this?.$layoutTree == this.$parent) {
      this.$layoutTree.recordPageChange();
    }
  };
  if (!Vue.prototype.$eventBus) {
    Object.defineProperty(Vue.prototype, "$eventBus", {
      get() {
        if (!$bus) {
          $bus = new Vue();
        }
        return $bus;
      },
      enumerable: false
    });
  }
  dsf.$systemGlobalSetting = systemGlobalSetting;
  window.$$unitTest = false;
  const i18nNameSpace = "namespace.";

  //多页签混入路由方法
  Vue.use(multiRouter);
  //对window对象注入_spv_对象
  if (!window._spv_) {
    Object.defineProperty(window, "_spv_", {
      get() {
        let topWindow = dsf.getTopWindow();
        let spv = topWindow.__multiPageVm__;
        return spv || null;
      }
    });
  }

  //全局通用混入
  Vue.mixin({
    inject: {
      $serviceInfo: {
        default: null
      }
    },
    beforeCreate() {
      // this.$dialogAll = [];
      //创建$http访问入口
      injectionHttp.call(this);
      //创建共同的webpi访问入口
      injectionWebAPI.call(this);
      //输入系统皮肤、字体配置
      injectionSystemSetting.call(this);
    },
    // destroyed() {
    //   _.each(this.$dialogAll, (it) => {
    //     it?.close();
    //   });
    //   this.$dialogAll = null;
    //   delete this.$dialogAll;
    // },
    created() {
      // 获取根元素的国际化对象
      const rootVmI18n = document.querySelector("#app")?.__vue__?.$i18n;
      if (!this.$i18n) {
        if (rootVmI18n) {
          // 可能存在组件注册在body上，导致vue-i18n无法正确给组件赋予国际化对象，所以强制把根节点的国际化对象赋予它
          this._i18n = rootVmI18n;
        } else {
          //兼容一下没有i18n的情况,创建一个空的$t函数
          this.$t = function (key) {
            return key;
          };
        }
      }
      if (this.$i18n || rootVmI18n) {
        this.$$t = this.$t;
        this.$t = function (...args) {
          let key = args[0];
          if (key.startsWith(i18nNameSpace) && this.$vm) {
            key = key.replace(i18nNameSpace, "$" + this.$vm.$options.name + ".");
          }
          return this.$$t.apply(this, args);
        };
      }
    },
    // mounted() {
    //   开启单元测试
    //   if (window.$$unitTest === true) {
    //     //判断_fromDesigner为true表示平台配置的页面
    //     this.$data._fromDesigner && attachUnitTest.call(this, "loaded");
    //   }
    // },
    computed: {
      $service() {
        return this?.$serviceInfo || {};
      },
      //页面服务名统一变更为$baseUrl
      $baseUrl() {
        return this?.$service?.baseUrl || "";
      },
      //兼容老版本服务名属性
      $servicePrefix() {
        return this?.$baseUrl;
      }
      // ...(dsf.global.$isMobile ? mobileDefaultComputed() : {})
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        //埋点监听路由进入
        dsf.UBA.urlWatch("routerEnter", to, from, vm);
        //开启单元测试
        // vm.$unitTest();
        //自动打开或者关闭水印
        vm.$autoWaterHandler(to, from);
      });
    },
    beforeRouteLeave(to, from, next) {
      //埋点监听路由离开
      dsf.UBA.urlWatch("routerLeave", to, from, this);
      /**
       * 路由切换时候强制关闭所有弹窗,如果是加载配置页面，此处可能执行两次
       */
      let dialogs = this.$router?.apps[0]?.$dialogAll || [];
      let disabledResult = _.filter(dialogs, (it) => it.autoCloseConfig.routerChange == "disabled");
      let closedResult = _.filter(dialogs, (it) => it.autoCloseConfig.routerChange == "close");
      // //禁止路由切换操作
      if (disabledResult.length) {
        next(false);
      } else {
        _.eachRight(closedResult, (it) => it?.close?.());
        Vue.nextTick().then(() => next());
      }
    },
    // updated() {
    //    console.log(this.$options.name+this._uid)
    // },
    // beforeUpdate(){
    //   console.time(this.$options.name+this._uid)
    // },
    methods: {
      // $unitTest() {
      //   if (window.$$unitTest === true) {
      //     !this.$data._fromDesigner && attachUnitTest.call(vm, "loaded");
      //   }
      // },
      $warterOn(state) {
        warterOn(this, state);
      },
      $autoWaterHandler(to, from) {
        //防截图水印,判断开启水印,且页面必须是需要登录时
        let warter_on = false;
        const sow = ~~dsf.config.setting_public_on_watermark;
        if (sow && dsf.getToken()) {
          //如果路由中有waterMark存在则以页面的为准,如果路由中不存在waterMark存在则配置为准
          warter_on = dsf.isDef(to?.meta?.waterMark) ? to.meta.waterMark : !!sow;
        }
        this.$warterOn(warter_on);
      },
      $expressParams(data, props) {
        let vm = this?.$vm;
        let viewData = this?.$vm?.$viewData;
        let dataview = this?.$vm?.$dataview;
        let self = this;
        if (this.$isLayoutView) {
          vm = this;
          viewData = this.$viewData;
          dataview = this.$dataview;
        }
        let obj = {
          $vm: {
            value: vm
          },
          $viewData: {
            value: viewData
          },
          $dataview: {
            value: dataview
          },
          $self: {
            value: self
          }
        };
        if (props) {
          for (let k in props) {
            obj[k] = {
              value: props[k]
            };
          }
        }
        return Object.create(data || {}, obj);
      },
      //打开新窗口
      $openWindow() {
        let args = Array.prototype.slice.call(arguments, 0);
        let vm = this.$vm ? this.$vm : this;
        return dsf.layer.openWindow.apply(vm, args);
      },
      //打开模态框
      $openDialog() {
        let args = Array.prototype.slice.call(arguments, 0);
        let vm = this.$vm ? this.$vm : this;
        args.push(() => {
          vm = null;
          args = null;
        });
        return dsf.layer.openDialog.apply(vm, args);
      },
      //打开抽屉，移动端同$openDialog
      $openDrawer() {
        let args = Array.prototype.slice.call(arguments, 0);
        let vm = this.$vm ? this.$vm : this;
        args.push(() => {
          vm = null;
          args = null;
        });
        const fn = dsf.global.$isMobile ? "openDialog" : "openDrawer";
        return dsf.layer[fn].apply(vm, args);
      },
      pxToRem(v) {
        return dsf.pxToRem(v);
      },
      unitSize(v, unit = "px") {
        return dsf.unitSize(v, unit);
      },
      //为vue对象注入表达式替换
      $replace(express, varible, isUrlDecode) {
        if (isUrlDecode) {
          express = express.replace(/%40%5b(((?!%5d).)*)%5d/gi, (a, b) => {
            return "@[" + decodeURIComponent(b) + "]";
          });
        }
        if (dsf.isUnDef(varible)) {
          varible = createExpressVarible(this);
        }
        // varible = dsf.mix(true, defaultVarible || {}, varible)
        return dsf.express.replace.call(this, express, varible);
      },
      //为vue对象注入表达式执行
      $eval(express, varible, isUrlDecode) {
        if (isUrlDecode) {
          express = express.replace(/%40%5b(((?!%5d).)*)%5d/gi, (a, b) => {
            return "@[" + decodeURIComponent(b) + "]";
          });
        }
        if (dsf.isUnDef(varible)) {
          varible = createExpressVarible(this);
        }
        // let defaultVarible = createExpressVarible(this);
        // varible=Object.create(varible,defaultVarible||{})

        return dsf.express.eval.call(this, express, varible);
      },
      // 改变国际化
      $setI18n(lang) {
        // element 国际化文件名称
        const elementI18nPath = {
          zh_CN: "zh",
          en_US: "en"
        };
        const hasLang = $i18n[lang];
        if (hasLang) {
          this.$i18n.locale = lang;
          dsf.http
            .importFiles([
              dsf.url.getWebPath(`$/js/libs/element-ui/lib/locale/lang/${elementI18nPath[lang]}.js`)
            ])
            .then((res) => {
              ELEMENT.locale(ELEMENT.lang[lang]);
            });
        }
      },
      $getWebPath(url, baseUrl) {
        let burl = "";
        if (dsf.type(baseUrl) == "boolean" && baseUrl === true) {
          //为true表示强行在$vm指定的微服务前缀下调用接口
          //如果当前组件继承了control则可以直接过去到当前页面微服务名称
          let servicePrefix = this.$baseUrl || "";
          burl = servicePrefix;
        } else if (dsf.type(baseUrl == "string")) {
          burl = baseUrl;
        }
        return dsf.url.getWebPath(url, burl);
      }
      // ...(dsf.global.$isMobile ? mobileDefaultFunction() : {})
    }
  });
  // 全局混入ws
  Vue.use(wsInstall);

  //执行各个包初始化函数
  _.each(initFns, (fn) => {
    fn();
  });

  const isDemo = (window.frameElement || window).name == "appDemo";
  if (isDemo) {
    document.documentElement.style.setProperty("--safe-area-inset-bottom", "20px");
  }
  dsf.performance.end("初始化dsf");
  // startLoginTimer();
}

// function startLoginTimer() {
//   if (dsf.getToken()) {
//     let time = new Date();
//     if (!sessionStorage.getItem(startKey)) {
//       time = new Date(startTime);
//       sessionStorage.setItem(startKey, time.getTime());
//     }
//     startTime = parseInt(sessionStorage.getItem(startKey));
//     let clearId = null;
//     var timerFn = function () {
//       if (clearId) {
//         window.clearTimeout(clearId);
//       }
//       if (!sessionStorage.getItem(startKey)) {
//         sessionStorage.setItem(startKey, startTime);
//       }
//       window.setTimeout(() => {
//         let time1 = new Date();
//         let start = parseInt(sessionStorage.getItem(startKey));
//         let span = time1.getTime() - start;
//         sessionStorage.setItem(timerKey, span);
//         timerFn();
//       }, 1000);
//     };
//     timerFn();
//   }
// }
// function autoHideColComponent() {
//   if (this?.$parent?.$options?._componentTag == "DsfCol") {
//     this.$parent.resize();
//   }
// }
//水印开关
function warterOn(vm, state) {
  if (dsf.client.info.browser == "IE" && dsf.client.info.version != "11.0") {
    state = false;
  }
  vm.$store.commit("userInfoWaterMark/" + (state ? "on" : "off"));
}

// function attachUnitTest(fnName) {
//   if (window.$$unitTest === true) {
//     if (dsf.unitTest.pages[this.$route.fullPath]) {
//       let query = this.queryString ? this.queryString : this.$route.query;
//       let method = null;
//       if (dsf.unitTest.pages[this.$route.fullPath][fnName]) {
//         method = dsf.unitTest.pages[this.$route.fullPath][fnName];
//       }
//       if (fnName == "loaded") {
//         if (this.nameSpace) {
//           this.$watch("$isReady", function (v, ov) {
//             v && method && method(this, query);
//           });
//         } else {
//           method && method(this, query);
//         }
//       }
//     }
//   }
// }
function httpProxy(methodName, path, params, options, baseUrl) {
  if (dsf.type(options) == "string" || dsf.type(options) == "boolean") {
    baseUrl = options;
    options = null;
  }
  if (dsf.type(baseUrl) == "boolean") {
    //为true表示强行在$vm指定的微服务前缀下调用接口
    if (baseUrl === true) {
      //如果当前组件继承了control则可以直接过去到当前页面微服务名称
      let servicePrefix = this.$baseUrl || "";
      if (servicePrefix) {
        //如果config.js中配置过serviceFullPath，则以前缀获取映射的完整路径，通常用于移动端离线页面
        if (dsf.config.serviceFullPath[servicePrefix]) {
          servicePrefix = dsf.config.serviceFullPath[servicePrefix];
        }
        path = dsf.url.getWebPath(path, servicePrefix);
        baseUrl = "/";
      } else {
        baseUrl = "";
      }
      // path = servicePrefix ? dsf.url.getWebPath(path, servicePrefix) : path;
    }
  }
  let httpFn = dsf.http[methodName](path, params, options, baseUrl);
  return httpFn;
}

function injectionWebAPI() {
  let api = dsf.api.getAPI();
  Object.defineProperty(this, "$webAPI", {
    get() {
      let _this = this;
      if (!_this.$$webapi) {
        _this.$$webapi = {};
        for (let k in api) {
          _this.$$webapi[k] = api[k].bind(_this);
        }
      }
      return _this.$$webapi;
    },
    enumerable: false
  });
}

function injectionHttp() {
  let _dsf = this.$options.dsf || this.dsf;
  let _this = this;
  Object.defineProperty(this, "$http", {
    get: function () {
      if (!_this.$$http) {
        let $$http = dsf.mix(true, {}, _dsf.http, {
          get() {
            let args = Array.prototype.slice.call(arguments, 0);
            return httpProxy.apply(_this, ["get", ...args]);
          },
          post() {
            let args = Array.prototype.slice.call(arguments, 0);
            return httpProxy.apply(_this, ["post", ...args]);
          },
          upload() {
            let args = Array.prototype.slice.call(arguments, 0);
            return httpProxy.apply(_this, ["upload", ...args]);
          }
        });
        Object.defineProperty(_this, "$$http", {
          value: $$http,
          enumerable: false
        });
      }
      return _this.$$http;
    },
    enumerable: false
  });
}
//注入系统级别访问变量
function injectionSystemSetting() {
  Object.defineProperty(this, "$system", {
    get() {
      //皮肤，字体
      return {
        setting: dsf.themeConfig.setting
      };
    },
    enumerable: false
  });
}

function createExpressVarible(com, varible) {
  let vm = "$vm" in com ? com.$vm : null;
  let local = "local" in com ? com.local : null;
  //如果不是配置页面$vm是不存在的，当然如果非要伪造一个$vm我也没办法
  if (!vm) {
    return null;
  }
  let mark = false;
  if (dsf.isDef(local)) {
    if (!local.$vm) {
      mark = true;
    }
  } else {
    local = {};
    mark = true;
  }
  if (mark) {
    local = Object.create(local, {
      $vm: {
        value: vm
      },
      $viewData: {
        value: vm.$viewData
      }
    });
  }
  return local;
}

function registerInitCall(fn) {
  initFns.push(fn);
}

export default {
  globalMixin,
  registerInitCall,
  preloads,
  initRouter,
  initPlatform
};
